import React, {useRef} from 'react';
import Tags from "@yaireo/tagify/dist/react.tagify";

const RecipientsField = ({ value, onChange, error }) => {
    const tagifyRef = useRef(null);

    return (
        <div className="bottom-side">
            <label>RECIPIENTS</label>
            <Tags
                ref={tagifyRef}
                whitelist={value}
                placeholder='Recipients'
                settings={{
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                }}
                onChange={onChange}
                defaultValue={Array.isArray(value) ? value.join(',') : ""}
                className={error ? 'error-tagify' : undefined}
            />
            {error && <span style={{ color: '#d32f2f', fontSize: '12px' }}>This field is required</span>}
        </div>
    );
};

export default RecipientsField;
